// apps/admin/src/hooks/useAdImages.ts

import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse, AdImageWithTag } from '@magnetar/admin-api-interfaces'

interface UseAdImagesParams {
  includeInactive?: boolean
}

export function useAdImages(
  supplierId: number | null | undefined,
  params: UseAdImagesParams = {},
) {
  const { token } = useAuth()

  const queryParams = new URLSearchParams()
  if (params.includeInactive) queryParams.set('includeInactive', 'true')
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : ''

  const { data, error, mutate, isLoading } = useGet<ApiResponse<AdImageWithTag[]>>(
    token && supplierId ? `/api/ad-supplier/${supplierId}/ad-images${queryString}` : null,
    undefined,
    token ?? '',
  )

  return {
    adImages: data?.data || [],
    isLoading,
    isError: error,
    mutate,
  }
}
